import type { AuthStatus } from "@/types/auth-status";

export const extractUserData = (
  authStatus?: AuthStatus
): { email: string; name: string } => {
  if (!authStatus || !authStatus.strategy) return { name: "", email: "" };

  if (authStatus.strategy === "user-specified") {
    return authStatus.userData;
  }

  let storage: Storage;

  switch (authStatus.strategy) {
    case "sessionStorage":
      storage = sessionStorage;
      break;
    default:
      storage = localStorage;
      break;
  }

  try {
    if (authStatus.method === "string") {
      return {
        email: storage.getItem(authStatus.userKeys.email) || "",
        name: storage.getItem(authStatus.userKeys.name) || "",
      };
    }

    if (authStatus.method === "object" && authStatus.objectName) {
      const userObjectRaw = storage.getItem(authStatus.objectName);
      if (!userObjectRaw) return { email: "", name: "" };

      const parsed = JSON.parse(userObjectRaw);
      return {
        email: parsed[authStatus.userKeys.email] || "",
        name: parsed[authStatus.userKeys.name] || "",
      };
    }
  } catch (err) {
    console.error("Error extracting user data:", err);
  }

  return { email: "", name: "" };
};
